import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SeasonLink as Link } from '../../components/Seasons/SeasonLink';
import { completeSfeduSignIn } from '../../api/auth';
import { useAuth } from '../../context/AuthContext';
import { SfeduLinkConfirmation } from './SfeduLinkConfirmation';
import './AuthPage.css';

const messages = {
  cancelled: 'Вход отменён. Вы можете попробовать ещё раз.',
  expired: 'Время ожидания истекло. Начните вход через ЮФУ заново в этом браузере.',
  not_linked: 'Эта учётная запись ЮФУ ещё не подключена. Войдите в свой аккаунт ЮФУ.Про, откройте «Настройки» и нажмите «Подключить учётную запись ЮФУ».',
  account_exists: 'Аккаунт с такой почтой уже есть на ЮФУ.Про. Войдите прежним способом, откройте «Настройки» и нажмите «Подключить учётную запись ЮФУ». Так сохранятся ваши команды, баллы и история.',
  profile_missing: 'ЮФУ не передал адрес электронной почты. Зарегистрируйтесь с почтой, затем подключите учётную запись ЮФУ в настройках. Если аккаунт уже есть, войдите прежним способом.',
  already_linked: 'У одной из учётных записей уже есть другая привязка. Войдите прежним способом и обратитесь в поддержку: sfedupro@yandex.com.',
  unavailable: 'Аккаунт недоступен. Обратитесь в поддержку: sfedupro@yandex.com.',
  failed: 'Не удалось завершить вход через ЮФУ. Попробуйте снова.'
};

export function SfeduCallback() {
  const [params] = useSearchParams();
  const reason = params.get('error');
  const confirmation = params.get('confirm') === '1' && !reason;
  const [error, setError] = useState(reason ? (messages[reason] || messages.failed) : '');
  const request = useRef(null);
  const navigate = useNavigate();
  const { refreshSession } = useAuth();

  useEffect(() => {
    let active = true;
    if (confirmation) return undefined;
    if (reason) {
      setError(messages[reason] || messages.failed);
      return undefined;
    }
    // The one-use exchange must happen once, including React StrictMode.
    if (!request.current) {
      request.current = completeSfeduSignIn().then(async result => {
        await refreshSession();
        return result;
      });
    }
    request.current.then(result => {
      if (active) navigate(result.linked ? '/settings' : '/my-season', { replace: true });
    }).catch(err => {
      if (active) setError(err.message || messages.failed);
    });
    return () => { active = false; };
  }, [reason, confirmation, navigate, refreshSession]);

  if (confirmation) return <SfeduLinkConfirmation />;

  return <div className="auth-container">
    <div className="auth-form-container auth-form-container-full">
      <div className="auth-card auth-card-compact auth-verification">
        <span className="auth-verification-mark" aria-hidden="true">ЮФУ</span>
        <h1 className="auth-title">Вход через ЮФУ</h1>
        {error ? <>
          <p className="auth-link auth-link-error" role="alert">{error}</p>
          <Link to="/login?method=password" className="auth-button auth-verification-login">Перейти ко входу</Link>
          {['not_linked', 'profile_missing'].includes(reason) && <p className="auth-link">
            Нет аккаунта ЮФУ.Про? <Link to="/register?method=email" className="auth-link-register">Зарегистрироваться</Link>
          </p>}
        </> : <p className="auth-link" role="status">Завершаем вход…</p>}
      </div>
    </div>
  </div>;
}
